<template>
  <a-modal width="70%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>选择秒杀商品</b>
    </a-divider>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="商品名称" prop="goodsName">
                <a-input v-model="queryParam.goodsName" :maxLength="50" placeholder="请输入商品名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 提示信息 -->
      <a-alert
        message="仅显示正在秒杀活动中的商品"
        type="info"
        show-icon
        style="margin-bottom: 16px;"
      />
      <!-- 数据展示 -->
      <a-table
        :scroll="{ x: '150%' }"
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :pagination="false"
        :bordered="tableBordered"
      >
        <template slot="picture" slot-scope="text, record">
          <div>
            <img v-if="record.goodsPicture" :src="record.goodsPicture" style="width:60px;height:62px;" @click="handleRecordPreview(record.goodsPicture)" alt="none"/>
          </div>
        </template>
        <span slot="startTime" slot-scope="text">
          {{ parseTime(text) }}
        </span>
        <span slot="endTime" slot-scope="text">
          {{ parseTime(text) }}
        </span>
        <span slot="checkStatus" slot-scope="text">
          <a-tag :color="getStatusColor(text)">{{ getStatusText(text) }}</a-tag>
        </span>
        <span slot="complete" slot-scope="text">
          <a-tag :color="text === '1' ? 'red' : 'green'">{{ text === '1' ? '已抢完' : '可购买' }}</a-tag>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </a-modal>
</template>

<script>
import { pageSeckill } from '@/api/zb/seckill'
import {mapGetters} from 'vuex'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'RadioGoodsSelectForm',
  props: {},
  components: {
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      open: false,
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        goodsName: null,
        checkStatus: '3', // 只查询审核通过的
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '商品编号',
          dataIndex: 'goodsId',
          width: 100,
        },
        {
          title: '商品名称',
          dataIndex: 'goodsName',
          width: 150,
        },
        {
          title: '商品图片',
          dataIndex: 'goodsPicture',
          width: 90,
          scopedSlots: {customRender: 'picture'},
        },
        {
          title: '商品原价',
          dataIndex: 'goodsPrice',
          width: 100,
        },
        {
          title: '秒杀价格',
          dataIndex: 'seckillPrice',
          width: 100,
        },
        {
          title: '秒杀库存',
          dataIndex: 'stock',
          width: 90,
        },
        {
          title: '已秒杀数量',
          dataIndex: 'seckillNum',
          width: 100,
        },
        {
          title: '开始时间',
          dataIndex: 'startTime',
          width: 160,
          scopedSlots: {customRender: 'startTime'}
        },
        {
          title: '结束时间',
          dataIndex: 'endTime',
          width: 160,
          scopedSlots: {customRender: 'endTime'}
        },
        {
          title: '审核状态',
          dataIndex: 'checkStatus',
          width: 100,
          scopedSlots: {customRender: 'checkStatus'},
        },
        {
          title: '库存状态',
          dataIndex: 'complete',
          width: 90,
          scopedSlots: {customRender: 'complete'},
        }
      ]
    };
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.resetQuery()
    },
    /**
     * 打开商品选择弹窗
     * @param records 已选中的商品ID列表
     */
    openGoods(starId, records) {
      console.log(11111,starId, records)
      if (records) {
        this.selectedRowKeys = records;
      }
      this.getList()
      this.open = true;
    },
    onOk() {
      // 判断有没有选择,拿到列表里选择的
      this.open = false
      this.$emit('goodsSelect', this.selectedRows)
      console.log(22222,this.selectedRows)
      this.resetQuery()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.resetQuery()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 查询秒杀商品列表 */
    getList () {
      this.loading = true
      pageSeckill(this.queryParam).then(response => {
        // 过滤正在进行的秒杀活动（审核通过且未结束）
        const now = new Date().getTime()
        this.list = (response.data.records || []).filter(item => {
          if (item.checkStatus !== 3) return false
          const startTime = item.startTime ? new Date(item.startTime).getTime() : 0
          const endTime = item.endTime ? new Date(item.endTime).getTime() : 0
          const isOngoing = startTime <= now && now <= endTime
          return isOngoing
        })
        this.total = this.list.length
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.queryParam = {
        goodsName: null,
        checkStatus: '3',
        pageNum: 1,
        pageSize: 10
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    getStatusColor(status) {
      const colorMap = {
        '1': 'orange',  // 待审核
        '2': 'red',     // 审核失败
        '3': 'green',   // 审核成功
        '4': 'default', // 过期未审核
        '5': 'default'  // 活动已结束
      }
      return colorMap[status] || 'default'
    },
    getStatusText(status) {
      const textMap = {
        '1': '待审核',
        '2': '审核失败',
        '3': '审核通过',
        '4': '过期未审核',
        '5': '活动已结束'
      }
      return textMap[status] || status
    }
  }
}
</script>
